module.exports = function getResource(label, vars = []) {
    let resources = {
        selectProduct: 'Sélectionnez votre produit actuel pour'
    };

    return resources[label];
};
